import DOMPurify from "isomorphic-dompurify";

/**
 * Sanitizes a user input string to prevent prompt injection, base64 payloads, HTML/script injection, and encoded attacks.
 * @param input - The raw input string to sanitize.
 * @returns A sanitized version of the string safe for LLM usage.
 */
export function sanitizeForLLM(input: string) {
  let sanitized = DOMPurify.sanitize(input);

  return {
    sanitized,
    original: input,
    isSafe: sanitized === input,
  };
}
